import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AiTemplatePrompt',
  props: {
    hasContent: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    error: { default: '' }
  },
  emits: ["submit", "close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'submit', prompt: string): void
  (e: 'close'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { hasContent: boolean, loading: boolean, error: string }





const prompt = ref('')

function submit() {
  if (props.loading || !prompt.value.trim()) return
  emit('submit', prompt.value.trim())
}

return { __sfc: true,props, emit, prompt, submit }
}

})